export default __webpack_public_path__ + "media/d7de7c0e3ec4817c7c1ab563ced790e5a7206d8172c066e8907b73620695f1d5.svg";